import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const ArrowDoneIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M23.53 0.150001C23.06 -0.139999 22.45 6.25849e-07 22.15 0.470001L9.11996 21.32L1.75996 12.72C1.39996 12.3 0.769961 12.25 0.349961 12.61C-0.0700388 12.97 -0.120039 13.6 0.239961 14.02L8.48996 23.64C8.89996 24.15 9.75996 24.08 10.1 23.52L23.85 1.53C24.14 1.06 24 0.450001 23.53 0.150001Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

ArrowDoneIcon.displayName = 'ArrowDoneIcon';
